import auth from './auth';
import product from './product';
import user from './user';
import firebase from './firebase';
import cart from './cart';
import order from './order';
import address from './address';

export default {
    user,
    auth,
    product,
    firebase,
    cart,
    order,
    address,
};
